import getPropClasses from 'lib/getPropClasses';
import cx from 'classnames';
import * as React from 'react';

import './styles/ImageWrapper.scss';

/**
 * ## Wraps figures that have different heights in order to retain subsequent content alignment.
 *
 *
 * ```example
 * <div style={{ display: 'flex' }}>
 *   <div style={{ background: '#17a687' }}>
 *     <ImageWrapper size="xsmall">
 *       <Glyph
 *         name="remind-icon"
 *         size="xxxlarge"
 *       />
 *     </ImageWrapper>
 *   </div>
 *   <div style={{ background: '#5fc4bb' }}>
 *     <ImageWrapper size="xsmall">
 *       <Glyph
 *         name="remind-icon"
 *         size="xlarge"
 *       />
 *     </ImageWrapper>
 *   </div>
 * </div>
 * ```
 *
 *
 * # TODO
 * * Add default centering
 */

type Props = {
  shape?: 'circle';
  size?: 'small' | 'xsmall';
  className?: string;
};

class ImageWrapper extends React.Component<Props> {
  static propClasses = {
    shape: {
      circle: 'ImageWrapper--circle',
    },
    size: {
      small: 'ImageWrapper--small',
      xsmall: 'ImageWrapper--xsmall',
    },
  };

  render() {
    const { children, className } = this.props;

    return (
      <div
        className={cx(
          'ImageWrapper',
          getPropClasses(this.props, ImageWrapper.propClasses),
          className
        )}>
        {children}
      </div>
    );
  }
}

export default ImageWrapper;
